<template>
    <div class="title">
        <h1>{{ text }}</h1>
    </div>
</template>

<script>
    export default {
        props:{
            text:String,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style.less" ;
</style>